import RentListContainer from './RentListContainer';
export default RentListContainer;
